import { render, staticRenderFns } from "./Author.vue?vue&type=template&id=582a3982&scoped=true"
import script from "./Author.vue?vue&type=script&lang=js"
export * from "./Author.vue?vue&type=script&lang=js"
import style0 from "./Author.vue?vue&type=style&index=0&id=582a3982&prod&lang=css"
import style1 from "./Author.vue?vue&type=style&index=1&id=582a3982&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "582a3982",
  null
  
)

export default component.exports